class LcpObserver {
  constructor() {
    this.count = 0;
    if (PerformanceObserver) {
      const observer = new PerformanceObserver( list => this.observe(list) );
      observer.observe({type:"largest-contentful-paint", buffered:true});
    }
    this.queue = [];
  }
  observe( list ) { 
    const entries = list.getEntries();
    const xentries = entries.map( e => {
      return {
        name: e.name,
        entryType: e.entryType,
        startTime: e.startTime,
        duration: e.duration,
        renderTime: e.renderTime,
        loadTime: e.loadTime,
        size: e.size,
        id: e.id,
        url: e.url,
        xpath: this.xpath(e.element),
      }
    });

    let count = ++this.count;
    let fetcher = ()=> {
      console.log(`starting lcp_observer fetch ${count}`);
      let body = {
          "entries": xentries,
          "count": count,
          "screen": {
            "availWidth": window.screen.availWidth,
            "availHeight": window.screen.availHeight,
            "width": window.screen.width,
            "height": window.screen.height,
          },
          "url": document.location.toString(),
          "uuid": this.uuid(),
        };
      if (this.visit_id) {
        body["visit_id"] = this.visit_id;
      }
      this.fetch = fetch("/wp-json/lcp_observer/v1/measure", {
        method: `POST`,
        body: JSON.stringify(body),
      })
      .then(res=>res.json())
      .then(res => {
        console.log(`lcp_observer/v1/measure returned `, res);
        this.visit_id = res.visit_id;
      }).catch( console.error )
      .finally( ()=>{
        console.log(`finished lcp_observer fetch ${count}`);
        this.fetch = null;
        if (0<this.queue.length) {
          this.queue.splice(0,1)[0]();
        }
      });
    };
    // if we're busy with a current measure, we wait for it to complete before sending the next measure,
    // since we want to get our visit_id
    if (this.fetch) {
      console.log(`queued lcp_observer fetch ${count}`);
      this.queue.push(fetcher);
    } else {
      fetcher();
    }
  }
  uuid() {
    const key = "lcp_observer_uuid";
    let uuid = localStorage.getItem(key);
    if (uuid) {
      return uuid;
    }
    uuid = crypto.randomUUID();
    localStorage.setItem(key, uuid);
    return uuid;
  }
  xpath(el) {
    let arr = [];
    while (el && el.nodeType != Node.DOCUMENT_NODE) {
      let desc = el.nodeName;
      if ('HTML'!=desc) {
        // find the index of the node for all nodes except HTML
        let n = 1;
        let sib = el.previousElementSibling;
        while (sib) {
          n++;
          sib = sib.previousElementSibling;
        }
        desc += `:nth-child(${n})`;
        if (el.id) {
          desc += "#" + el.id;
        }
      }
      arr.unshift(desc);
      el = el.parentNode;
    }
    return arr.join(">");
  }
}
new LcpObserver();